module.exports = __webpack_public_path__ + "static/media/bfile-employed.f9ad2734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-employed.svg
// module id = 971
// module chunks = 0